<div *ngIf="modalType === 'confirmation'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1>Confirm requirement</h1>
        <p>Once initiated you cannot select a new contract requirement.</p>
        <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
        <alaska-button class="button continue" primary style="float: right" (click)="onContinue()"> Continue </alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'manualConfirmation'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1>Confirm manual payment</h1>
        <p>Please confirm that you'll be completing the payment manually.</p>
        <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
        <alaska-button class="button continue" primary style="float: right" (click)="onManualContinue()"> Continue </alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'exitToiCargo'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="exitModal modal">
        <div>
          <h1>Please confirm</h1>
          <p>Selecting this option will cancel the transaction. Are you sure you wish to continue?</p>
        </div>
        <div>
          <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
          <alaska-button class="button continue" primary style="float: right" (click)="onConfirmExit()"> Continue </alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
        </div>
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'creditCard'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [ngClass]="isBluefinTokenRetry? 'bluefinRetry modal' : 'bluefin modal'">
        <app-bluefin [cargoPaymentInfo]="cargoPaymentInfo" [transactionId]=""></app-bluefin>        
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'connectIpad'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1>Turn on device</h1>
        <p>Please ensure the iPad device and application are on.</p>
        <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
        <alaska-button class="button continue" primary style="float: right" (click)="onContinue()"> Continue </alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'spinner'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1 style="text-align: center">Searching for devices...</h1>
        <span class="loader"></span>
      </div>
    </section>
  </ng-container>
</div>
<div *ngIf="modalType === 'noDevices'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1>No Devices Available</h1>
        <p>Please ensure the iPad device is on and try connecting again.</p>
        <alaska-button class="button cancel only" primary (click)="close()">Close</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
      </div>
    </section>
  </ng-container>
</div>
<div *ngIf="modalType === 'deviceList'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [ngClass]="checkSearchTermLength() ? 'devicesExpanded modal' : 'devices modal'">
        <h1>Select a device to connect to</h1>
        <alaska-searchbar id="searchBar" ngDefaultControl name="searchBar" predictive="true" placeholder="Enter device POS name here">
          <alaska-predictive-menu category class="deviceList">
            <alaska-predictive-item> Search Result </alaska-predictive-item>
            <alaska-predictive-item *ngFor="let device of filteredDeviceList" value="{{ device.deviceId }}" (click)="ipadSelected(device)" (keydown.enter)="ipadSelected(device)" (keydown.space)="ipadSelected(device)">
              {{ device.deviceId }}
            </alaska-predictive-item>
            <alaska-predictive-item nomatch>No matching options</alaska-predictive-item>
          </alaska-predictive-menu>
        </alaska-searchbar>
        <div>
          <alaska-button class="button cancel" secondary style="float: left" (click)="close()">Cancel</alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
          <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click --><alaska-button
            class="button continue"
            [disabled]="isContinueDeviceSelected()"
            primary
            style="float: right"
            (click)="onContinueDeviceSelected()"
            >Continue</alaska-button
          >
        </div>
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'paymentInfo'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal" style="width: 345px; height: 325px">
        <h1>Payment methods</h1>
        <b>Customer payment:</b>
        <p style="margin-top: auto">Station Agents use this option to prompt customers to complete payments on their own using an iPad.</p>
        <b>Agent manual payment:</b>
        <p style="margin-top: auto">
          Station Agents use this option to complete payments for customers if there are iPad issues. Call Center Agents use this option to
          complete payments manually.
        </p>
        <alaska-button class="button continue" primary style="float: right" (click)="close()"> Close </alaska-button> <!-- //NOSONAR alaska-button renders a native <button>, so Enter/Space already fire click -->
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'spinnerRefreshPos'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1 style="text-align: center">Refreshing POS Device</h1>
        <span class="loader"></span>
      </div>
    </section>
  </ng-container>
</div>

<div *ngIf="modalType === 'spinnerRefreshPos'">
  <ng-container *ngIf="display$ | async as display">
    <section [class.open]="display === 'open'">
      <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="modal">
        <h1 style="text-align: center">Refreshing POS Device</h1>
        <span class="loader"></span>
      </div>
    </section>
  </ng-container>
</div>
